"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var sizeAvatarL = _a.sizeAvatarL,
      sizeAvatarS = _a.sizeAvatarS,
      sizeAvatarM = _a.sizeAvatarM,
      sizeAvatarXL = _a.sizeAvatarXL,
      sizeAvatarXS = _a.sizeAvatarXS,
      colorBgSecondary = _a.colorBgSecondary,
      colorError = _a.colorError,
      colorSuccess = _a.colorSuccess;
  return {
    avatar: {
      fontSize: 0,
      textAlign: 'center',
      display: 'inline-block',
      position: 'relative',
      borderRadius: '100%',
      overflow: 'hidden',
      width: sizeAvatarM,
      height: sizeAvatarM,
      lineHeight: sizeAvatarM + "px",
      backgroundColor: colorBgSecondary.normal,
      '& > svg,& > $inner': {
        display: 'inline-block',
        verticalAlign: 'middle'
      }
    },
    success: {
      backgroundColor: colorSuccess.normal
    },
    warning: {
      backgroundColor: colorError.normal
    },
    tiny: {
      width: sizeAvatarXS,
      height: sizeAvatarXS,
      lineHeight: sizeAvatarXS + "px"
    },
    small: {
      width: sizeAvatarS,
      height: sizeAvatarS,
      lineHeight: sizeAvatarS + "px"
    },
    large: {
      width: sizeAvatarL,
      height: sizeAvatarL,
      lineHeight: sizeAvatarL + "px"
    },
    huge: {
      width: sizeAvatarXL,
      height: sizeAvatarXL,
      lineHeight: sizeAvatarXL + "px"
    },
    square: {
      borderRadius: 0
    },
    fluid: {
      width: '100%',
      height: '100%',
      lineHeight: 'inherit'
    },
    inner: {}
  };
};